import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";


export const paymentSettingStyle = StyleSheet.create({
    containerView: {
        flex: 1
    },
    listContainer: {
        margin: 10, borderRadius: 16, paddingHorizontal: 10, paddingVertical: 10, backgroundColor: appColors.light, elevation: 1
    },
    headerContainer: {
        flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 10, alignItems: 'center'
    },
    paymentTypeContainer: {
        flexDirection: 'row', paddingHorizontal: 10, paddingVertical: 5
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
        height: 15,
        paddingHorizontal: 5,
    },
    badgeTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.lightDark,
    },
    badgeContainerStyle: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
    },
    labelStyle: {
        fontSize: fontSize.smallFontSize, color: appColors.labelColor,
    },
    errorStyle: {
        fontSize: fontSize?.errorFontSize, fontFamily: appFonts?.medium, color: appColors?.red,
    },
    floatingButtonContainer: { flexDirection: 'row', margin: 10, justifyContent: 'center', alignSelf: 'flex-end', marginBottom: 10 },
    switchStyle: { transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }], },
    toolKitView: { flexDirection: 'row', alignItems: 'center' },
    inputContainerStyle: { marginTop: 10, right: 10, height: 60, flex: 1, },
    viewStyle: { paddingHorizontal: 10, marginTop: 10, },
    incrementPointViewStyle: { paddingHorizontal: 10, marginVertical: 10, flexDirection: 'row', flex: 1 },
    checkBoxView: { right: 20, flex: 1 }

})